<template>
  <div class="article-add">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/city-look-and-revise'}">城市管理</el-breadcrumb-item>
      <el-breadcrumb-item>城市群二维码添加</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="upload-qrcode">
      <div class="upload-container">
        <div class="coint1">
          <div class="address-form">
            <el-cascader
              v-model="selectedOptions"
              :options="regionData"
              placeholder="请选择省市区"
              clearable
            ></el-cascader>
          </div>
        </div>

        <button class="upload-button" @click="uploadQRCode">点击上传二维码</button>
        <input
          id="file-input"
          type="file"
          accept="image/png, image/jpeg"
          style="display: none;"
          ref="fileInput"
          @change="handleFileChange"
        />
      </div>
      <div class="preview-container">
        <span v-if="!previewImage" class="placeholder-text">请先填写省市信息</span>
        <img v-else :src="previewImage" alt="Uploaded QR Code" class="preview-image" />
      </div>
      <button class="submit-button" @click="submit">确定</button>
    </div>
  </div>
</template>

<script>
import { regionData, codeToText } from 'element-china-area-data';
import axios from "axios";

export default {
  data() {
    return {
      regionData: regionData,
      selectedOptions: [],
      previewImage: '',
      selectedFile: null,
      clickBool:false
    };
  },
  methods: {
    uploadQRCode() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (!this.isValidImageType(file)) {
          this.$message.error('只允许上传PNG和JPEG格式的图片');
          return;
        }
        if (!this.isValidImageSize(file)) {
          this.$message.error('图片大小超过限制');
          return;
        }

        this.selectedFile = file;
        this.previewImage = URL.createObjectURL(file);


      }
    },
    goOff(){
      this.$router.go(-1);
    },
    isValidImageType(file) {
      const allowedTypes = ['image/png', 'image/jpeg'];
      return allowedTypes.includes(file.type);
    },
    isValidImageSize(file) {
      const maxSize = 500 * 1024; // 500KB
      return file.size <= maxSize;
    },

    translate(){
      // 声明一个新数组
      let address = []
      // 遍历旧数组，push每个转译后编码进去address
      this.selectedOptions.forEach(item => {
        address.push(codeToText[item])
      })
      return address
    },
    submit() {
      // 在此处执行将文件上传到后端的操作
      // 使用 this.selectedFile 发送到后端
      // ...
      if(this.clickBool){
        this.$message('正在上传请稍等')
        return
      }
      this.clickBool=true
      let address=this.translate(this.selectedOptions)
      let addName=address[0]+address[1]+address[2]
      const formData = new FormData();
      formData.append('qrcodeRUL', this.selectedFile);
      formData.append('province',addName);
      // 创建XMLHttpRequest对象

      axios.post('/v1/admin/province-group-qrcode', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // 设置请求头为multipart/form-data
        },
      })
        .then((response) => {
          // 请求成功处理逻辑
          this.clickBool=false;
          this.selectedFile=null;
          this.selectedOptions=[]
          this.previewImage=''
          this.$message.success('上传成功')
          this.goOff()
        })
        .catch((error) => {

        });


    },
  },
};
</script>

<style scoped>
.article-add {
  text-align: center;

}
.coint1{
  margin-top: 40px;
  margin-bottom: 40px;
}
.upload-qrcode {
  display: inline-block;
  text-align: center;
}

.upload-container {
  margin-bottom: 20px;
}

.upload-button {
  padding: 12px 20px;
  background-color: #409eff;
  color: #fff;
  cursor: pointer;
}

#file-input {
  display: none;
}

.preview-container {
  margin-bottom: 20px;
  border: 1px solid #ccc;
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.placeholder-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #999;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
}

.submit-button {
  padding: 12px 20px;
  background-color: #409eff;
  color: #fff;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/CityManage/CityGroupAdd.vue